export default "__VITE_ASSET__CMkfZ7WZ__"